import React from 'react';
import { ExternalLink } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4">Mitz Traders</h3>
            <p className="text-gray-300 mb-4 max-w-md">
              Your trusted partner in global trading and e-commerce solutions. 
              Specialising in import/export, product sourcing, and retail support 
              with a commitment to excellence and customer satisfaction.
            </p>
            <div className="flex items-center space-x-2">
              <span className="text-gray-300">Visit our marketplace:</span>
              <a 
                href="https://mitzcart.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 font-medium transition-colors duration-200 flex items-center"
              >
                MitzCart.com
                <ExternalLink className="ml-1" size={16} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Import/Export</li>
              <li>Product Sourcing</li>
              <li>Retail Support</li>
              <li>Quality Assurance</li>
              <li>Logistics Solutions</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-300 mb-4 md:mb-0">
              <p>&copy; {currentYear} Mitz Traders. All rights reserved.</p>
            </div>
            
            <div className="flex items-center space-x-6 text-gray-300">
              <span>Contact: +44 7587 768456</span>
              <span>•</span>
              <span>Prakash@mitztraders.co.uk</span>
            </div>
          </div>
          
          <div className="text-center mt-4 text-gray-400 text-sm">
            <p>Mitz Traders - Trading & E-commerce Excellence • mitztraders.co.uk</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;